import { CarFront, CircleCheckBig, Phone, Truck } from 'lucide-react';

type StepIcon = typeof Phone;

export default function ProcessSection() {
  const steps: Array<{ number: string; title: string; description: string; icon: StepIcon }> = [
    {
      number: '01',
      title: 'Kontakt & Einsatzziel',
      description:
        'Sie schildern kurz, was passiert ist, wo das Fahrzeug steht und wohin es gebracht werden soll.',
      icon: Phone
    },
    {
      number: '02',
      title: 'Absicherung & Anfahrt',
      description:
        'Wir prüfen die Lage, sichern den Ablauf ab und fahren realistisch disponiert zum Standort.',
      icon: CarFront
    },
    {
      number: '03',
      title: 'Verladung & Transport',
      description:
        'Das Fahrzeug wird fachgerecht aufgenommen und zur Werkstatt, zum Wunschort oder zur Verwahrstelle gebracht.',
      icon: Truck
    },
    {
      number: '04',
      title: 'Übergabe & Rückmeldung',
      description:
        'Zum Schluss klären wir offene Punkte und halten den Vorgang sauber nachvollziehbar fest.',
      icon: CircleCheckBig
    }
  ];

  return (
    <section className="bg-[#f4f1ea] py-16 text-slate-950" aria-labelledby="process-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold text-amber-700">Ablauf</p>
          <h2 id="process-heading" className="mt-3 text-3xl font-semibold leading-tight sm:text-4xl">
            So läuft der Einsatz bei Schiek ab.
          </h2>
          <p className="mt-4 text-base leading-8 text-slate-700">
            Vier Schritte, keine Schleifen. So bleibt der Ablauf im Notfall verständlich und auf mobilem Bildschirm gut lesbar.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <article
                key={step.number}
                className="rounded-[1.5rem] border border-slate-300 bg-white p-5 shadow-[0_14px_30px_rgba(15,23,42,0.06)]"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="text-sm font-semibold text-amber-700">Schritt {step.number}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 text-slate-950">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                </div>
                <h3 className="mt-4 text-lg font-semibold text-slate-950">{step.title}</h3>
                <p className="mt-3 text-sm leading-7 text-slate-700">{step.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
